import { useAtomValue } from 'jotai';

import { isSpecialApiSourceForOperatorText } from '@shared/utils/general';
import { dcbAtom } from '@shared/store/slice-atoms';
import { useTranslation } from 'react-i18next';

export const useOperatorText = (): string | null => {
  const { homeData, operatorSelectedDetails, subscribeData } = useAtomValue(dcbAtom);
  const { t } = useTranslation();
  const apiSource = homeData?.source || '';

  if (isSpecialApiSourceForOperatorText(apiSource)) {
    const dailyThirdText = homeData.operators
      ?.map((el) => el?.dailyThirdText || '')
      .filter((el) => el)?.[0];
    const weeklyThirdText = homeData.operators
      ?.map((el) => el?.weeklyThirdText || '')
      .filter((el) => el)?.[0];
    const monthlyThirdText = homeData.operators
      ?.map((el) => el?.monthlyThirdText || '')
      .filter((el) => el)?.[0];

    if (dailyThirdText) return dailyThirdText;

    if (weeklyThirdText) return weeklyThirdText;

    if (monthlyThirdText) return monthlyThirdText;
  }

  if (subscribeData?.removeTopDisclaimer) return null;

  const { dailyPrice, weeklyPrice, monthlyPrice } = operatorSelectedDetails || {};

  const extraText =
    operatorSelectedDetails?.dailyThirdText ||
    operatorSelectedDetails?.weeklyThirdText ||
    operatorSelectedDetails?.monthlyThirdText ||
    '';

  if (extraText) return extraText;

  const plansWithOr: string[] = [];
  let freeSubscriptionText = '';
  if (dailyPrice) {
    plansWithOr.push(operatorSelectedDetails.dailyText);
    freeSubscriptionText = freeSubscriptionText
      ? freeSubscriptionText
      : operatorSelectedDetails.dailySecondText;
  }
  if (weeklyPrice) {
    plansWithOr.push(operatorSelectedDetails.weeklyText);
    freeSubscriptionText = freeSubscriptionText
      ? freeSubscriptionText
      : operatorSelectedDetails.weeklySecondText;
  }
  if (monthlyPrice) {
    plansWithOr.push(operatorSelectedDetails.monthlyText);
    freeSubscriptionText = freeSubscriptionText
      ? freeSubscriptionText
      : operatorSelectedDetails.monthlySecondText;
  }

  if (!plansWithOr.length) {
    return null;
  }

  const plansWithOrText = plansWithOr.join(' or ');

  return `${
    freeSubscriptionText?.charAt(0).toUpperCase() + freeSubscriptionText?.slice(1).toLowerCase()
  } ${t('then')} ${plansWithOrText} (${t('vat_inclusive')})`;
};
